import { useAction, useAtom } from '@reatom/npm-react'
import { useEffect } from 'react'

import { redirectToAuthEvent, userAtom } from '@root/entities/auth'
import { environmentAtom, isTauriOrBrowserLocalAtom } from '@root/shared'

import { chooseGuard } from '../model/choose-guard'

import type { UserStatus } from '@root/entities/auth'
import type { ChildrenProps } from '@root/shared/react'

type Props = {
  userStatusesOnly?: ReadonlyArray<UserStatus>
} & ChildrenProps

export const AuthenticatedOnly: React.FC<Props> = ({
  children,
  userStatusesOnly,
}) => {
  const redirectToAuth = useAction(redirectToAuthEvent)
  const [environment] = useAtom(environmentAtom)
  const [isTauriOrBrowserLocal] = useAtom(isTauriOrBrowserLocalAtom)
  const [isAllowed] = useAtom((ctx) => {
    const user = ctx.spy(userAtom)
    if (!user) {
      return false
    }
    if (userStatusesOnly === undefined) {
      return true
    }

    return userStatusesOnly.includes(user.status)
  })

  const guard = chooseGuard({
    isAllowed,
    isApp: isTauriOrBrowserLocal,
    isDev: environment.isDev,
  })

  useEffect(() => {
    if (guard === 'sign-in') {
      redirectToAuth()
    }
  }, [guard, redirectToAuth])

  if (guard === 'render') {
    return children
  }

  return undefined
}
